(() => {
  const selector = '.ironbeard-product-brief__accordion details';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.ironbeard-product-brief__accordion summary');
    if (!summary) return;

    const details = summary.parentElement;
    if (!details?.matches(selector) || reducedMotion.matches) return;

    const content = details.querySelector('.accordion__content');
    if (!content || details.dataset.animating === 'true') return;

    event.preventDefault();
    details.dataset.animating = 'true';
    content.getAnimations().forEach((animation) => animation.cancel());

    if (!details.open) {
      details.open = true;
      details.classList.remove('is-closing');

      const height = content.scrollHeight;
      const animation = content.animate(
        [
          { height: '0px', opacity: 0, transform: 'translateY(-4px)' },
          { height: `${height}px`, opacity: 1, transform: 'translateY(0)' },
        ],
        { duration: 260, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
      );

      animation.onfinish = () => {
        content.style.height = '';
        content.style.opacity = '';
        content.style.transform = '';
        delete details.dataset.animating;
      };
    } else {
      details.classList.add('is-closing');
      const height = content.getBoundingClientRect().height;
      const animation = content.animate(
        [
          { height: `${height}px`, opacity: 1, transform: 'translateY(0)' },
          { height: '0px', opacity: 0, transform: 'translateY(-4px)' },
        ],
        { duration: 220, easing: 'cubic-bezier(0.4, 0, 1, 1)' }
      );

      animation.onfinish = () => {
        details.open = false;
        details.classList.remove('is-closing');
        content.style.height = '';
        content.style.opacity = '';
        content.style.transform = '';
        delete details.dataset.animating;
      };
    }
  });
})();
